import CircularProgress from "@mui/material/CircularProgress";

const Loader = () => {
  return <CircularProgress color="primary" />;
};

export default Loader;
